export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  POLICY: '/policy',
  TERMS: '/terms',
  SUPPLY: '/supply',
  TEO: '/teo',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: (token: string) => `/auth/reset-password/${token}`,
  VERIFY_EMAIL: (token: string) => `/auth/verify-email/${token}`,
  INVITATION: (token: string) => `/auth/invitation/${token}`,
  // Приём приглашения сотрудника: сюда ведёт ссылка из письма, учётной записи ещё нет
  EMPLOYEE_INVITATION: (token: string) => `/auth/employee-invitation/${token}`,
  // Приём имперсонации Identix: сюда ведёт redirect с ?code=… (url_template impersonation-site).
  IMPERSONATION_CALLBACK: '/impersonation/callback',
  APP: '/app',
  APP_AGENT_DASHBOARD: '/app/market',
  APP_CARRIER: '/app/carrier',
  APP_CARRIER_NEW: '/app/carrier/new',
  APP_CARRIER_IN_WORK: '/app/carrier/in-work',
  APP_CARRIER_DONE: '/app/carrier/done',
  APP_CARRIER_INTEGRATION_ADMIN: '/app/carrier/integration/admin',
  APP_CARRIER_INTEGRATION_DEV: '/app/carrier/integration/dev',
  APP_CARRIER_REQUESTS: '/app/carrier/requests',
  /** Мастер взятия заявки: договор → заявка → подпись. */
  APP_CARRIER_REQUEST_TAKE: '/app/carrier/requests/:id/take',
  APP_PROFILE: '/app/profile',
  APP_PROFILE_SECURITY: '/app/profile/security',
  APP_PROFILE_API: '/app/profile/api-access',
  APP_COMPANY: '/app/company',
  APP_COMPANY_BANKING: '/app/company/banking',
  APP_COMPANY_ACCREDITATION: '/app/company/accreditation',
  APP_COMPANY_AGENCY: '/app/company/agency',
  APP_COMPANY_EMPLOYEES: '/app/company/employees',
  APP_AUDIT: '/app/audit',
  APP_BUY: '/app/buy',
  APP_BUY_GROUP: '/app/buy/group',
  APP_BUY_OFFER: '/app/buy/offer',
  APP_BUY_NEW: '/app/buy/new',
  APP_BUY_EDIT: '/app/buy/edit',
  APP_SELL: '/app/sell',
  APP_SELL_OFFER: '/app/sell/offer',
  APP_SELL_COUNTER: '/app/sell/counter',
  APP_SELL_BEST_PRICE: '/app/sell/best-price',
  APP_SELL_NEW: '/app/sell/new',
  APP_SELL_EDIT: '/app/sell/edit',
  APP_DEALS: '/app/deals',
  APP_CHAT: '/app/chat',
  APP_BEST_PRICE: '/app/best-price',
  SUPPORT_URL: 'https://t.me/data1861_support_bot',
  NOT_FOUND: '/404',
} as const;
